import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["isOpen", "setIsOpen"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/components/PreviewModal.tsx
import { useEffect as useEffect2, useState as useState3 } from "react";
import { Button as Button2, Grid, Modal } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage3, useIntl as useIntl2 } from "react-intl";
import { addDataLayerEntry as addDataLayerEntry3 } from "@printdeal/data-layer-manager";

// src/hooks/usePreviews.ts
import { getViews } from "@rendering/lookup";
import { useQuery, useQueryClient } from "@tanstack/react-query";

// src/clients/anonymousCoamIdentity.ts
import { configurationProvider } from "@printdeal/configuration";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { authenticationHttpClient } from "@printdeal/authentication";

// src/helpers/WindowHelper.ts
var windowPresent = typeof window !== "undefined";
var getFromLocalStorage = key => {
  if (!windowPresent) {
    return void 0;
  }
  return window.localStorage.getItem(key);
};
var saveToLocalStorage = (key, value) => {
  if (!windowPresent) {
    return;
  }
  window.localStorage.setItem(key, value);
};

// src/clients/anonymousCoamIdentity.ts
var isDecodedTokenExpired = decodedToken => {
  if (!decodedToken.exp) {
    return true;
  }
  return Boolean(decodedToken.exp <= Math.floor(( /* @__PURE__ */new Date()).getTime() / 1e3));
};
var createAnonymousCOAMIdentity = async identity => {
  const {
    data: {
      token: printdealAuthToken
    }
  } = await authenticationHttpClient.createToken();
  const {
    data
  } = await axios.post("".concat(configurationProvider.getValue("AUTH_LAYER_API_BASE_URL"), "/anon-coam-identity"), identity, {
    headers: {
      Authorization: printdealAuthToken
    }
  });
  return data;
};
var getAnonymousCOAMIdentity = async () => {
  const identityFromStorage = getFromLocalStorage("anonCoamIdentity");
  if (!identityFromStorage) {
    const newIdentity = await createAnonymousCOAMIdentity();
    saveToLocalStorage("anonCoamIdentity", JSON.stringify(newIdentity));
    return newIdentity;
  }
  const parsedIdentityFromStorage = JSON.parse(identityFromStorage);
  const decodedToken = jwtDecode(parsedIdentityFromStorage.anonymousToken);
  if (isDecodedTokenExpired(decodedToken)) {
    const newIdentity = await createAnonymousCOAMIdentity(parsedIdentityFromStorage);
    saveToLocalStorage("anonCoamIdentity", JSON.stringify(newIdentity));
    return newIdentity;
  }
  return parsedIdentityFromStorage;
};

// src/hooks/usePreviews.ts
var TENANT = {
  id: "148",
  type: "fulfillers"
};
var getMcpToken = async () => {
  const mcpToken = await getAnonymousCOAMIdentity();
  if (!mcpToken) {
    throw new Error("MCP token not found");
  }
  return mcpToken.anonymousToken;
};
var fetchAllViews = async (mcpSku, mcpAttributes) => {
  try {
    return await getViews({
      authorizationHeader: "Bearer ".concat(await getMcpToken()),
      request: {
        reference: {
          id: mcpSku,
          attributes: mcpAttributes
        },
        tenant: TENANT
      }
    });
  } catch (error) {
    throw new Error("Error fetching views: ".concat(error instanceof Error ? error.message : "Unknown error"));
  }
};
var getViewsBasedOnVariant = _ref => {
  let {
    variant,
    previewsQuery
  } = _ref;
  const {
    data: views
  } = previewsQuery;
  if (!views) {
    return [];
  }
  const isScene = (view, sceneType) => view.type === "scene" && view.purpose.toLowerCase() === "design" && view.scene.type === sceneType;
  const isPhotographic = view => isScene(view, "photographic");
  const isPhotographicPresent = viewsArray => viewsArray.some(isPhotographic);
  const isDynamicPresent = viewsArray => viewsArray.some(view => isScene(view, "dynamic") && view.subPurpose.toLowerCase() === "underlay");
  const isProduct = view => view.type === "scene" && view.purpose.toLowerCase() === "product" && ["full", "fullbleed"].includes(view.subPurpose.toLowerCase());
  const sceneViews = views.filter(view => isPhotographic(view));
  const uniquePhotographicViews = sceneViews.length > 0 && sceneViews.filter((view, index, self) => index === self.findIndex(obj => "scene" in obj && "id" in obj.scene && "scene" in view && "id" in view.scene && obj.scene.id === view.scene.id));
  const filteredPhotographicViews = isPhotographicPresent(views) && !isDynamicPresent(views) && uniquePhotographicViews;
  const getFilteredScenes = () => {
    const productFullScene = views.filter(view => view.type === "scene" && view.purpose.toLowerCase() === "product" && view.subPurpose.toLowerCase() === "full");
    if (productFullScene.length > 0) {
      return productFullScene;
    }
    return views.filter(view => view.type === "scene" && view.purpose.toLowerCase() === "design" && view.subPurpose.toLowerCase() === "underlay");
  };
  const result = {
    "2d": filteredPhotographicViews ? uniquePhotographicViews : views.filter(view => isProduct(view)),
    "3d": views.filter(view => view.type === "vortex"),
    "scene": getFilteredScenes(),
    "all": views
  };
  return result[variant];
};
var usePreviews = _ref2 => {
  let {
    mcpSku,
    mcpAttributes,
    variant = "all",
    enabled = true
  } = _ref2;
  const queryClient = useQueryClient();
  const previewsQuery = useQuery({
    enabled,
    queryKey: ["views-lookup", mcpSku, mcpAttributes],
    queryFn: async () => fetchAllViews(mcpSku, mcpAttributes),
    placeholderData: () => queryClient.getQueryData(["views-lookup", mcpSku, mcpAttributes]),
    retry: 1,
    // retry 1 time if the query fails
    retryDelay: 1e3
    // retry after 1 second
  });
  const previewsByVariant = getViewsBasedOnVariant({
    variant,
    previewsQuery
  });
  return {
    data: previewsByVariant,
    status: previewsQuery.status
  };
};

// src/components/Preview2D.tsx
import { useMemo, useState } from "react";
import { Preview as RenderingPreview } from "@rendering/product-preview-react";
import { FormattedMessage, useIntl } from "react-intl";
import { Pagination, Spinner } from "@printdeal/ui-library";
import { addDataLayerEntry } from "@printdeal/data-layer-manager";

// src/hooks/useDocRef.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
import axios2 from "axios";
var useDocRefQuery = documentReferenceUrl => useQuery2({
  queryKey: ["documentReference", documentReferenceUrl],
  queryFn: async () => {
    const response = await axios2.get(documentReferenceUrl);
    return response.data;
  }
});

// src/components/Preview2D.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var defaultReferrer = "@printdeal/previews";
var Preview2D = _ref3 => {
  let {
    referer = defaultReferrer,
    mcpSku,
    mcpAttributes,
    documentReferenceUrl,
    pagination = false,
    setCurrentPreview,
    onError = console.error,
    // eslint-disable-line no-console
    // Max height is used in place of height for maintaining aspect ratio of the previews
    style = {
      maxHeight: 550
    }
  } = _ref3;
  const intl = useIntl();
  const [pageIndex, setPageIndex] = useState(1);
  const {
    data: views,
    status: viewsStatus
  } = usePreviews({
    mcpSku,
    mcpAttributes,
    variant: "2d"
  });
  const {
    data: documentReference,
    status: docrefStatus
  } = useDocRefQuery(documentReferenceUrl);
  const isPending = viewsStatus === "pending" || docrefStatus === "pending";
  const isError = viewsStatus === "error" || docrefStatus === "error";
  const user = useMemo(() => ({
    tenant: TENANT,
    referer
  }), [referer]);
  const cimDocUrl = useMemo(() => documentReference === null || documentReference === void 0 ? void 0 : documentReference.cimDocUrl, [documentReference]);
  if (isPending || !cimDocUrl) {
    return /* @__PURE__ */jsx("div", {
      children: /* @__PURE__ */jsx(Spinner, {
        size: "xl"
      })
    });
  }
  if (isError) {
    addDataLayerEntry("previews_error", {
      component: "previews2D",
      error: "Error occured!"
    });
    return /* @__PURE__ */jsx("div", {
      children: /* @__PURE__ */jsx(FormattedMessage, {
        id: "preview.error",
        defaultMessage: "Error occured!"
      })
    });
  }
  if (!views.length) {
    addDataLayerEntry("previews_error", {
      component: "previews2D",
      error: "No preview present!"
    });
    return /* @__PURE__ */jsx("div", {
      children: /* @__PURE__ */jsx(FormattedMessage, {
        id: "preview.not.present",
        defaultMessage: "No preview present!"
      })
    });
  }
  if (pagination && setCurrentPreview) {
    const currentView = views[pageIndex - 1];
    if (currentView.type === "scene") {
      setCurrentPreview(currentView);
    }
  }
  const switchPage = pageNumber => {
    addDataLayerEntry("switch_page", {
      component: "previews 2D",
      page: pageNumber
    });
    setPageIndex(pageNumber);
    const currentView = views[pageIndex - 1];
    if (currentView.type === "scene") {
      setCurrentPreview === null || setCurrentPreview === void 0 || setCurrentPreview(currentView);
    }
  };
  return /* @__PURE__ */jsxs(Fragment, {
    children: [!pagination && views.map(scene => /* @__PURE__ */jsx(RenderingPreview, {
      user,
      cimDocUrl,
      view: scene,
      onError,
      children: _ref4 => {
        let {
          Canvas
        } = _ref4;
        return /* @__PURE__ */jsx(Canvas, {
          style: _objectSpread(_objectSpread({}, style), {}, {
            maxWidth: "100%"
          })
        });
      }
    })), pagination && /* @__PURE__ */jsxs("div", {
      className: "pd:row-span-12 pd:h-full",
      children: [/* @__PURE__ */jsx("div", {
        className: "pd:h-[".concat(style.maxHeight, "px] pd:row-span-10 pd:min-h-[80%] pd:content-center pd:justify-items-center"),
        children: /* @__PURE__ */jsx(RenderingPreview, {
          user,
          cimDocUrl,
          view: views[pageIndex - 1],
          onError,
          children: _ref5 => {
            let {
              Canvas
            } = _ref5;
            return /* @__PURE__ */jsx(Canvas, {
              style: _objectSpread(_objectSpread({}, style), {}, {
                maxWidth: "100%"
              })
            });
          }
        })
      }), /* @__PURE__ */jsx("div", {
        className: "pd:row-span-2 pd:py-5",
        children: /* @__PURE__ */jsx(Pagination, {
          className: "pd:justify-center",
          total: views.length,
          currentPage: pageIndex,
          perPage: 1,
          "aria-label": intl.formatMessage({
            id: "general.pagination.label",
            defaultMessage: "Pagination"
          }),
          children: _ref6 => {
            let {
              pages
            } = _ref6;
            return /* @__PURE__ */jsxs(Fragment, {
              children: [/* @__PURE__ */jsx(Pagination.Button, {
                as: "button",
                variant: "prev",
                onClick: switchPage,
                children: /* @__PURE__ */jsx(FormattedMessage, {
                  id: "general.pagination.button.previous",
                  defaultMessage: "Previous"
                })
              }), /* @__PURE__ */jsx(Pagination.Items, {
                children: pages.map(pageNumber => /* @__PURE__ */jsx(Pagination.Item, {
                  onClick: switchPage
                }, pageNumber))
              }), /* @__PURE__ */jsx(Pagination.Button, {
                as: "button",
                variant: "next",
                onClick: switchPage,
                children: /* @__PURE__ */jsx(FormattedMessage, {
                  id: "general.pagination.button.Next",
                  defaultMessage: "Next"
                })
              })]
            });
          }
        })
      })]
    })]
  });
};

// src/components/Preview3D.tsx
import { useMemo as useMemo2, useState as useState2, useEffect, useRef } from "react";
import { Preview as RenderingPreview2 } from "@rendering/product-preview-react";
import { Button, Spinner as Spinner2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage2 } from "react-intl";
import { addDataLayerEntry as addDataLayerEntry2 } from "@printdeal/data-layer-manager";

// src/messages.ts
import { defineMessages } from "react-intl";
var messages = defineMessages({
  fullTitle: {
    id: "preview.modal.scenes.full.title",
    defaultMessage: "Without trim"
  },
  fullDescription: {
    id: "preview.modal.scenes.full.description",
    defaultMessage: "Endproduct"
  },
  fullbleedTitle: {
    id: "preview.modal.scenes.fullbleed.title",
    defaultMessage: "With trim"
  },
  fullbleedDescription: {
    id: "preview.modal.scenes.fullbleed.description",
    defaultMessage: "The dotted line could be cut from the endproduct"
  },
  front: {
    id: "preview.action.front",
    defaultMessage: "Front"
  },
  back: {
    id: "preview.action.back",
    defaultMessage: "Back"
  },
  open: {
    id: "preview.action.open",
    defaultMessage: "Open"
  },
  close: {
    id: "preview.action.close",
    defaultMessage: "Close"
  },
  unfolded: {
    id: "preview.action.unfold",
    defaultMessage: "Unfold"
  },
  folded: {
    id: "preview.action.fold",
    defaultMessage: "Fold"
  }
});

// src/components/Preview3D.tsx
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var defaultReferrer2 = "@printdeal/previews";
var Preview3D = _ref7 => {
  let {
    referer = defaultReferrer2,
    mcpSku,
    mcpAttributes,
    documentReferenceUrl,
    onError = console.error,
    // eslint-disable-line no-console
    style = {
      height: 550
    }
  } = _ref7;
  const [painted, setPainted] = useState2(false);
  const {
    data: views,
    status: viewsStatus
  } = usePreviews({
    mcpSku,
    mcpAttributes,
    variant: "3d"
  });
  const {
    data: documentReference,
    status: docrefStatus
  } = useDocRefQuery(documentReferenceUrl);
  const isPending = viewsStatus === "pending" || docrefStatus === "pending";
  const isError = viewsStatus === "error" || docrefStatus === "error";
  const user = useMemo2(() => ({
    tenant: TENANT,
    referer
  }), [referer]);
  const cimDocUrl = useMemo2(() => documentReference === null || documentReference === void 0 ? void 0 : documentReference.cimDocUrl, [documentReference]);
  const renderOptions = useMemo2(() => ({
    vortex: "interactive",
    cameraViews: true,
    animations: true
  }), []);
  const showPreviewEmittedRef = useRef(false);
  const noPreviewEmittedRef = useRef({});
  const errorEmittedRef = useRef({});
  useEffect(() => {
    showPreviewEmittedRef.current = false;
    noPreviewEmittedRef.current = {};
    errorEmittedRef.current = {};
    setPainted(false);
  }, [mcpSku, cimDocUrl]);
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (isError && !errorEmittedRef.current[mcpSku]) {
      window.dispatchEvent(new CustomEvent("preview3d:error", {
        detail: {
          type: "generic_error",
          message: "An error occurred while loading 3D preview",
          mcpSku
        }
      }));
      addDataLayerEntry2("previews_error", {
        component: "previews3D",
        error: "Error occurred!"
      });
      errorEmittedRef.current[mcpSku] = true;
    } else if (!isPending && (!Array.isArray(views) || views.length === 0) && !noPreviewEmittedRef.current[mcpSku]) {
      window.dispatchEvent(new CustomEvent("preview3d:no-preview", {
        detail: {
          type: "no_preview",
          message: "No preview views available for 3D",
          mcpSku
        }
      }));
      noPreviewEmittedRef.current[mcpSku] = true;
    }
  }, [isPending, isError, views, mcpSku, cimDocUrl]);
  const handlePaint = () => {
    setPainted(true);
    if (!showPreviewEmittedRef.current && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("preview3d:show-preview", {
        detail: {
          type: "show_preview",
          message: "Show the 3D preview"
        }
      }));
      showPreviewEmittedRef.current = true;
    }
  };
  if (isError) {
    return /* @__PURE__ */jsx2("div", {
      style,
      children: /* @__PURE__ */jsx2(FormattedMessage2, {
        id: "preview.error",
        defaultMessage: "Error occurred!"
      })
    });
  }
  if (isPending || !cimDocUrl) {
    return /* @__PURE__ */jsx2(Spinner2, {
      size: "lg"
    });
  }
  if (!Array.isArray(views) || views.length === 0) {
    return /* @__PURE__ */jsx2("div", {
      style,
      children: /* @__PURE__ */jsx2(FormattedMessage2, {
        id: "preview.not.present",
        defaultMessage: "No preview present!"
      })
    });
  }
  return /* @__PURE__ */jsxs2("div", {
    className: "pd:h-full ".concat(painted ? "pd:block" : "pd:flex-none"),
    style,
    children: [!painted && /* @__PURE__ */jsx2("div", {
      className: "pd:flex pd:h-full pd:items-center pd:justify-center",
      children: /* @__PURE__ */jsx2(Spinner2, {
        size: "xl"
      })
    }), /* @__PURE__ */jsx2(RenderingPreview2, {
      user,
      cimDocUrl,
      view: views[0],
      onError,
      renderOptions,
      onPaint: handlePaint,
      children: _ref8 => {
        let {
          Canvas,
          renderActions
        } = _ref8;
        return /* @__PURE__ */jsxs2(Fragment2, {
          children: [/* @__PURE__ */jsx2("div", {
            className: "pd:flex pd:justify-center",
            children: /* @__PURE__ */jsx2(Canvas, {
              style: _objectSpread(_objectSpread({}, style), {}, {
                maxWidth: "100%"
              })
            })
          }), /* @__PURE__ */jsx2("div", {
            className: "pd:row-span-2 pd:flex pd:justify-center",
            children: renderActions && renderActions(_ref9 => {
              let {
                actions
              } = _ref9;
              const lastActionIndex = actions.length - 1;
              return actions.map((action, index) => {
                const buttonClass = lastActionIndex === index ? "pd:rounded-l-0" : "pd:rounded-t-0 pd:rounded-b-0";
                return /* @__PURE__ */jsx2(Button, {
                  className: "pd:button--md ".concat(index === 0 ? "pd:rounded-r-0" : buttonClass),
                  type: "button",
                  onClick: () => {
                    addDataLayerEntry2("previews_3d_".concat(action.name, "_click"));
                    action.onAnimate();
                  },
                  children: Object.hasOwn(messages, action.id.toLowerCase()) ? /* @__PURE__ */jsx2(FormattedMessage2, _objectSpread({}, messages[action.id.toLowerCase()])) : /* @__PURE__ */jsx2(FormattedMessage2, {
                    id: action.id,
                    defaultMessage: action.name
                  })
                }, action.id);
              });
            })
          })]
        });
      }
    })]
  });
};

// src/components/PreviewModal.tsx
import { Fragment as Fragment3, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var PreviewModal = _ref10 => {
  var _currentPreview$scene, _currentPreview$scene2;
  let {
      isOpen = false,
      setIsOpen
    } = _ref10,
    props = _objectWithoutProperties(_ref10, _excluded);
  const [is3D, setIs3D] = useState3(false);
  const [currentPreview, setCurrentPreview] = useState3(void 0);
  const {
    data: views
  } = usePreviews({
    mcpSku: props.mcpSku,
    mcpAttributes: props.mcpAttributes,
    variant: "3d"
  });
  const is3dEnabled = Array.isArray(views) && views.some(view => view.type === "vortex");
  useEffect2(() => {
    if (is3dEnabled) {
      setIs3D(true);
    }
  }, [is3dEnabled, isOpen]);
  const intl = useIntl2();
  return /* @__PURE__ */jsx3(Modal, {
    size: "xl",
    onClose: () => {
      addDataLayerEntry3("preview_modal_close", {
        component: "preview modal"
      });
      setIsOpen(false);
    },
    isOpen,
    title: intl.formatMessage({
      id: "preview.modal.title",
      defaultMessage: "Preview your design"
    }),
    dismissLabel: intl.formatMessage({
      id: "general.alert.dismiss",
      defaultMessage: "Dismiss"
    }),
    children: /* @__PURE__ */jsx3(Modal.Content, {
      className: "pd:h-[75vh]",
      children: /* @__PURE__ */jsxs3(Grid, {
        className: "pd:h-full pd:grid-cols-12 pd:gap-2",
        children: [/* @__PURE__ */jsx3(Grid.Item, {
          className: "pd:z-10 pd:col-span-1",
          children: is3dEnabled && /* @__PURE__ */jsxs3(Fragment3, {
            children: [/* @__PURE__ */jsx3(Button2, {
              className: "pd:block pd:rounded-b-0",
              variant: is3D ? "secondary" : "primary",
              onClick: () => {
                setIs3D(false);
                addDataLayerEntry3("2d_button_click", {
                  component: "preview modal",
                  mode: "2d"
                });
              },
              type: "button",
              children: /* @__PURE__ */jsx3(FormattedMessage3, {
                id: "preview.modal.mode.2d",
                defaultMessage: "2D"
              })
            }), /* @__PURE__ */jsx3(Button2, {
              className: "pd:block pd:rounded-t-0",
              variant: is3D ? "primary" : "secondary",
              onClick: () => {
                setIs3D(true);
                addDataLayerEntry3("3d_button_click", {
                  component: "preview modal",
                  mode: "3d"
                });
              },
              children: /* @__PURE__ */jsx3(FormattedMessage3, {
                id: "preview.modal.mode.3d",
                defaultMessage: "3D"
              })
            })]
          })
        }), /* @__PURE__ */jsx3(Grid.Item, {
          className: "".concat(is3D ? "pd:col-span-9" : "pd:col-span-8", " pd:flex pd:items-center pd:justify-center"),
          children: is3D ? /* @__PURE__ */jsx3(Preview3D, _objectSpread({}, props)) : /* @__PURE__ */jsx3(Preview2D, _objectSpread({
            pagination: true,
            setCurrentPreview
          }, props))
        }), !is3D && (currentPreview === null || currentPreview === void 0 || (_currentPreview$scene = currentPreview.scene.documents) === null || _currentPreview$scene === void 0 || (_currentPreview$scene = _currentPreview$scene[0]) === null || _currentPreview$scene === void 0 ? void 0 : _currentPreview$scene.page) && /* @__PURE__ */jsxs3(Grid.Item, {
          className: "pd:col-span-3 pd:overflow-hidden pd:break-words",
          children: [/* @__PURE__ */jsx3("h3", {
            children: /* @__PURE__ */jsx3(FormattedMessage3, {
              id: "preview.modal.scenes.page",
              defaultMessage: "Page {pageNumber}",
              values: {
                pageNumber: (_currentPreview$scene2 = currentPreview.scene.documents[0]) === null || _currentPreview$scene2 === void 0 ? void 0 : _currentPreview$scene2.page
              }
            })
          }), ["full", "fullbleed"].includes(currentPreview.subPurpose.toLowerCase()) && /* @__PURE__ */jsxs3(Fragment3, {
            children: [/* @__PURE__ */jsx3("span", {
              className: "pd:font-bold",
              children: /* @__PURE__ */jsx3(FormattedMessage3, {
                id: messages["".concat(currentPreview.subPurpose.toLowerCase(), "Title")].id
              })
            }), /* @__PURE__ */jsx3("p", {
              children: /* @__PURE__ */jsx3(FormattedMessage3, {
                id: messages["".concat(currentPreview.subPurpose.toLowerCase(), "Description")].id
              })
            })]
          })]
        })]
      })
    })
  });
};

// src/components/Preview.tsx
import { useMemo as useMemo3 } from "react";
import { Preview as RenderingPreview3 } from "@rendering/product-preview-react";
import { FormattedMessage as FormattedMessage4 } from "react-intl";
import { Spinner as Spinner3 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry4 } from "@printdeal/data-layer-manager";
import { jsx as jsx4 } from "react/jsx-runtime";
var defaultReferrer3 = "@printdeal/previews";
var Preview = _ref11 => {
  let {
    referer = defaultReferrer3,
    documentReferenceUrl,
    view,
    onError = console.error,
    // eslint-disable-line no-console
    // Max height is used in place of height for maintaining aspect ratio of the previews
    style = {
      maxHeight: 550
    }
  } = _ref11;
  const {
    data: documentReference,
    status: docrefStatus
  } = useDocRefQuery(documentReferenceUrl);
  const isPending = docrefStatus === "pending";
  const isError = docrefStatus === "error";
  const user = useMemo3(() => ({
    tenant: TENANT,
    referer
  }), [referer]);
  const cimDocUrl = useMemo3(() => documentReference === null || documentReference === void 0 ? void 0 : documentReference.cimDocUrl, [documentReference]);
  if (isPending || !cimDocUrl) {
    return /* @__PURE__ */jsx4("div", {
      children: /* @__PURE__ */jsx4(Spinner3, {
        size: "xl"
      })
    });
  }
  if (isError) {
    addDataLayerEntry4("previews_error", {
      component: "previews2D",
      error: "Error occured!"
    });
    return /* @__PURE__ */jsx4("div", {
      children: /* @__PURE__ */jsx4(FormattedMessage4, {
        id: "preview.error",
        defaultMessage: "Error occured!"
      })
    });
  }
  return /* @__PURE__ */jsx4(RenderingPreview3, {
    user,
    cimDocUrl,
    view,
    onError,
    children: _ref12 => {
      let {
        Canvas
      } = _ref12;
      return /* @__PURE__ */jsx4(Canvas, {
        style: _objectSpread(_objectSpread({}, style), {}, {
          maxWidth: "100%"
        })
      });
    }
  });
};
export { Preview, Preview2D, Preview3D, PreviewModal, getViewsBasedOnVariant, usePreviews };